import React from "react";
import PropTypes from "prop-types";
import TableSkeleton from "../Skeleton/TableSkeleton";
import AdvanceTable from "../../AdvanceTable";
import AdvanceTableFooter from "../../AdvanceTableFooter";
import AdvanceTablePagination from "../../AdvanceTablePagination";
import AdvanceTableWrapper from "../../AdvanceTableWrapper";
import SearchTable from "./SearchTable";
import * as FiIcons from "react-icons/fi";
import _ButtonExportExcel from "../../_ButtonExportExcel";

const Table = (props) => {
  const {
    loading = false,
    columns = [],
    data = [],
    config = {},
    rowRule = null,
    title = "",
  } = props;

  if (loading) return <TableSkeleton />;

  const defaultConfig = {
    pageSize: 10,
    perPage: 10,
    sortable: true,
    pagination: true,
    table: true,
    rowInfo: true,
    navButtons: false,
    rowsPerPageSelection: true,
    search: false,
    printfooter: false,
    footer: false,
    export: false,
    infoSize: "sm",
    iconInfoSize: 20,
  };

  const newConfig = {
    ...defaultConfig,
    ...config,
    rowCount: data.length ?? 0,
  };

  const renderTable = () => {
    if (loading || !data.length)
      return (
        <div className="flex justify-center items-center gap-2">
          <FiIcons.FiInbox
            style={{
              fontSize: `${newConfig.iconInfoSize}px`,
            }}
          />
          <div className={`text-${newConfig.infoSize}`}>
            No hay información disponible
          </div>
        </div>
      );

    return (
      <AdvanceTableWrapper
        columns={columns}
        data={data}
        sortable={newConfig?.sortable}
        pagination={newConfig?.pagination}
        perPage={newConfig?.perPage}
      >
        {newConfig?.export ? (
          <div className="flex justify-end gap-2">
            <_ButtonExportExcel dataReport={data} />
          </div>
        ) : (
          <></>
        )}
        {newConfig?.search ? <SearchTable table={newConfig?.table} /> : <></>}

        <AdvanceTable
          table={newConfig?.table}
          headerClassName="border-b border-slate-200 bg-slate-50"
          rowClassName="align-middle white-space-nowrap hover:bg-gray-400"
          tableProps={{
            size: "sm",
            striped: false,
            className: "border-gray-200 rounded-xl",
          }}
          printfooter={newConfig?.printfooter}
          rowRule={rowRule}
        />
        {newConfig?.footer ? (
          <div>
            <AdvanceTableFooter
              rowCount={data.length}
              table={newConfig?.table}
              rowInfo={newConfig?.rowInfo}
              navButtons={newConfig?.navButtons}
              rowsPerPageSelection={newConfig?.rowsPerPageSelection}
              pageSize={newConfig?.pageSize}
            />

            <AdvanceTablePagination table={newConfig?.table} />
          </div>
        ) : (
          <></>
        )}
      </AdvanceTableWrapper>
    );
  };

  return (
    <div className="w-full">
      <div className="text-md font-semibold mb-2">{title}</div>
      {renderTable()}
    </div>
  );
};

Table.propTypes = {
  loading: PropTypes.bool,
  columns: PropTypes.array,
  data: PropTypes.array,
  config: PropTypes.shape({
    pageSize: PropTypes.number,
    perPage: PropTypes.number,
    sortable: PropTypes.bool,
    pagination: PropTypes.bool,
    rowCount: PropTypes.number,
    rowInfo: PropTypes.bool,
    rowsPerPageSelection: PropTypes.bool,
    navButtons: PropTypes.bool,
    infoSize: PropTypes.string,
    iconInfoSize: PropTypes.number,
  }),
        rowRule: PropTypes.any,
  title: PropTypes.string,
};
export default Table;
